import Logo from '../../assets/logo.svg'
const AssessiveLogo = () => {
  return (
    <img
      src={Logo}
      alt="Assessive Logo"
      style={{
        position: "fixed",
        top: 6,
        left: 6,
        zIndex: 10000
      }}
    />
  );
};

export default AssessiveLogo;
